// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"9ff1b6da","260":"4d151c47","425":"a276bbfb","471":"1db0891b"}[chunkId] + ".chunk.css";
};